module.exports = __webpack_public_path__ + "static/6ACO_Quatrix_protivpovratna_klapna-59740a2c30b5330e2f52ffb5185bc459.jpg";